var _rect, _path, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _g2, _rect10, _rect11, _rect12, _rect13, _rect14, _path2, _circle, _path3, _circle2, _rect15, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdLivelinessCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 57,
    viewBox: "0 0 74 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.32029,
    y: 43.5194,
    width: 43.6375,
    height: 61.6944,
    rx: 3.00948,
    transform: "rotate(-78.84 4.32029 43.5194)",
    fill: "#FCFAF9",
    stroke: "#29315D",
    strokeWidth: 1.20379
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2559 48.8118L42.4689 7.18045",
    stroke: "#9DA4BE",
    strokeWidth: 0.300948
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1973,
    y: 48.5891,
    width: 10.9966,
    height: 14.4903,
    rx: 1.17887,
    transform: "rotate(-78.84 43.1973 48.5891)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4277,
    y: 34.9778,
    width: 3.48228,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 43.4277 34.9778)",
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.1875,
    y: 51.6399,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 61.1875 51.6399)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4648,
    y: 50.2434,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 61.4648 50.2434)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.7422,
    y: 48.8469,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 61.7422 48.8469)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.0137,
    y: 47.4504,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 62.0137 47.4504)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.291,
    y: 46.054,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 62.291 46.054)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5664,
    y: 44.6555,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 62.5664 44.6555)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.8418,
    y: 43.259,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 62.8418 43.259)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.1191,
    y: 41.8645,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 63.1191 41.8645)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.3926,
    y: 40.4661,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 63.3926 40.4661)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.6699,
    y: 39.0676,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 63.6699 39.0676)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.9453,
    y: 37.6731,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 63.9453 37.6731)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.2188,
    y: 36.2766,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 64.2188 36.2766)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.4941,
    y: 34.8782,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 64.4941 34.8782)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7715,
    y: 33.4817,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 64.7715 33.4817)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.0469,
    y: 32.0852,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 65.0469 32.0852)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.3242,
    y: 30.6887,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 65.3242 30.6887)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5977,
    y: 29.2922,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 65.5977 29.2922)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.873,
    y: 27.8958,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 65.873 27.8958)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1484,
    y: 26.5012,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 66.1484 26.5012)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4258,
    y: 25.1008,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 66.4258 25.1008)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.7012,
    y: 23.7063,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 66.7012 23.7063)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.9766,
    y: 22.3098,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 66.9766 22.3098)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.25,
    y: 20.9114,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 67.25 20.9114)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.5254,
    y: 19.5149,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 67.5254 19.5149)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8027,
    y: 18.1184,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 67.8027 18.1184)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.0781,
    y: 16.72,
    width: 0.854206,
    height: 0.854206,
    rx: 0.427103,
    transform: "rotate(-78.84 68.0781 16.72)",
    fill: "#D9D9D9"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9746,
    y: 36.0696,
    width: 12.5832,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 48.9746 36.0696)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.7266,
    y: 36.6145,
    width: 16.9761,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 51.7266 36.6145)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55.9668,
    y: 37.4504,
    width: 3.48228,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 55.9668 37.4504)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0703,
    y: 26.8,
    width: 3.48228,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 58.0703 26.8)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4785,
    y: 37.9465,
    width: 7.10965,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 58.4785 37.9465)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5762,
    y: 27.2961,
    width: 7.10965,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 60.5762 27.2961)",
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8262,
    y: 27.8918,
    width: 2.9019,
    height: 1.53453,
    rx: 0.767267,
    transform: "rotate(-78.84 44.8262 27.8918)",
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1074,
    y: 21.3938,
    width: 6.77369,
    height: 1.55848,
    rx: 0.779238,
    transform: "rotate(-78.84 46.1074 21.3938)",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.8086,
    y: 13.1223,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 50.8086 13.1223)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3125,
    y: 13.4172,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 52.3125 13.4172)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8203,
    y: 13.7161,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 53.8203 13.7161)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.3242,
    y: 14.011,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 55.3242 14.011)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.832,
    y: 14.3079,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 56.832 14.3079)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.3359,
    y: 14.6067,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 58.3359 14.6067)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8418,
    y: 14.9036,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 59.8418 14.9036)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.3457,
    y: 15.2004,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 61.3457 15.2004)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.8496,
    y: 15.4973,
    width: 2.10664,
    height: 1.20379,
    rx: 0.601897,
    transform: "rotate(-78.84 62.8496 15.4973)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.9849,
    y: 8.61787,
    width: 9.46497,
    height: 9.09739,
    rx: 0.964798,
    transform: "rotate(10.6931 27.9849 8.61787)",
    stroke: "#D9D9D9",
    strokeWidth: 0.826859,
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -0.2296,
    y: -0.336565,
    width: 6.56041,
    height: 2.10731,
    transform: "matrix(0.98133 0.19233 -0.17895 0.983858 29.2519 10.913)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 0.572298,
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -0.2296,
    y: -0.336565,
    width: 6.56041,
    height: 2.10179,
    transform: "matrix(0.98133 0.19233 -0.17895 0.983858 28.4492 14.3446)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 0.572298,
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1855,
    y: 29.595,
    width: 4.83648,
    height: 10.9312,
    rx: 0.720855,
    transform: "rotate(47.3755 17.1855 29.595)",
    stroke: "#D9D9D9",
    strokeWidth: 0.902845
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0859,
    y: 32.0012,
    width: 1.42947,
    height: 7.52302,
    rx: 0.120379,
    transform: "rotate(47.3755 17.0859 32.0012)",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 0.902845
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8278 12.9457C22.0854 12.8071 22.1535 12.4684 21.9693 12.2411L17.8966 7.215C17.648 6.90826 17.1546 7.02973 17.0768 7.4168L15.4516 15.5059C15.3738 15.893 15.7821 16.1956 16.1298 16.0087L21.8278 12.9457Z",
    fill: "#D9D9D9",
    stroke: "#E2E3E9",
    strokeWidth: 0.752593
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7489,
    cy: 38.3575,
    r: 4.31881,
    transform: "rotate(11.16 26.7489 38.3575)",
    fill: "#D9D9D9"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.584 52.4812C52.9003 51.8238 53.1393 51.116 53.2871 50.367C54.2254 45.6106 51.1302 40.9941 46.3738 40.0558C41.6174 39.1174 37.0009 42.2126 36.0626 46.969C35.9148 47.718 35.8671 48.4635 35.9101 49.1918L42.3758 50.4673C41.8718 49.8223 41.6405 48.9701 41.8113 48.104C42.1234 46.5223 43.6586 45.4931 45.2403 45.8051C46.822 46.1171 47.8512 47.6523 47.5392 49.234C47.3683 50.1001 46.8307 50.8006 46.1195 51.2059L52.584 52.4812Z",
    fill: "#061656"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7914,
    cy: 48.6656,
    r: 3.08472,
    transform: "rotate(-78.84 44.7914 48.6656)",
    fill: "#E3E3E9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8145,
    y: 51.3313,
    width: 1.20379,
    height: 6.01897,
    transform: "rotate(-78.84 40.8145 51.3313)",
    fill: "#29315D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0782653 12.4076C0.0350405 12.1984 0.169609 11.9938 0.378833 11.9505L28.7491 6.08936C30.7024 5.68583 32.6129 6.94213 33.0165 8.89539L40.7477 46.3174C41.1512 48.2706 39.8949 50.1812 37.9417 50.5847L9.57139 56.4459C9.36216 56.4891 9.15751 56.3546 9.11429 56.1453L0.0782653 12.4076Z",
    fill: "#29315D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46779 27.8457L29.9892 23.6071",
    stroke: "#3158F2",
    strokeWidth: 1.1436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8469 35.9854C16.1666 37.1586 10.6402 33.5243 9.46694 27.844C8.29371 22.1636 11.928 16.6372 17.6084 15.464",
    stroke: "#3158F2",
    strokeWidth: 1.1436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6094 15.4661C23.2897 14.2928 28.8161 17.9272 29.9894 23.6075C31.1626 29.2878 27.5283 34.8142 21.848 35.9875",
    stroke: "#3158F2",
    strokeWidth: 1.1436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6081 15.464C13.4601 22.2434 15.3522 31.4042 21.8467 35.9854C25.9946 29.2061 24.1025 20.0453 17.6081 15.464Z",
    stroke: "#3158F2",
    strokeWidth: 1.1436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3107 41.2973L21.2645 42.3396C20.8073 42.434 20.5122 42.8827 20.6066 43.34L21.2873 46.6355C21.3817 47.0928 21.8305 47.3879 22.2877 47.2934L27.3339 46.2512C27.7912 46.1567 28.0863 45.708 27.9919 45.2507L27.3112 41.9552C27.2167 41.498 26.768 41.2028 26.3107 41.2973ZM27.3633 45.3805C27.3861 45.4911 27.3147 45.5998 27.2041 45.6226L22.1579 46.6649C22.0473 46.6877 21.9387 46.6162 21.9158 46.5057L21.6381 45.1609L23.0932 44.8604C23.3491 45.3999 23.9497 45.717 24.5601 45.5909C25.1705 45.4648 25.5963 44.9358 25.6176 44.339L27.0855 44.0358L27.3633 45.3805ZM23.6213 44.4303C23.5449 44.0606 23.7836 43.6977 24.1533 43.6213C24.523 43.545 24.8859 43.7837 24.9623 44.1533C25.0386 44.523 24.7999 44.886 24.4303 44.9623C24.0606 45.0387 23.6976 44.8 23.6213 44.4303ZM26.9557 43.4072L25.4845 43.7111C25.2254 43.1789 24.6293 42.8676 24.0235 42.9928C23.4177 43.1179 22.9937 43.6399 22.9665 44.2311L21.5083 44.5323L21.2352 43.2102C21.2123 43.0996 21.2838 42.991 21.3944 42.9681L26.4406 41.9259C26.5511 41.903 26.6598 41.9745 26.6826 42.0851L26.9557 43.4072Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 0.11605
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdLivelinessCheckLarge);
export default __webpack_public_path__ + "static/media/id_liveliness_check_large.fcfb892e25cf3ec0fb947e954c2fd557.svg";
export { ForwardRef as ReactComponent };